// extracted by mini-css-extract-plugin
module.exports = {"item":"advantages_item__1hsD0","included":"advantages_included__WETKd","excluded":"advantages_excluded__1ZIAl","mark":"advantages_mark__oO0ND"};